import { useSelector } from 'react-redux';
import { selectSelectedItem } from '@reducers/machines';
import { useNavigationCheck } from '@v2/pages/machines/hooks/useNavigationCheck';
import { Machine } from '@interfaces/machines';
import { injectConditionalArrayItems, ncFileStatuses } from '@helpers';
import { ProductionBatchStatistics } from '@interfaces/search';
import { selectSingleBatch } from '@reducers/batch';
import { KEYS_TAGS } from '@components/imageHandling/common';

export const useGetPreselectedScopeIds = () => {
  const machine: Machine = useSelector(selectSelectedItem);
  const batch: ProductionBatchStatistics = useSelector(selectSingleBatch);

  const { safeIsMachinesScreenCheck } = useNavigationCheck();

  if (safeIsMachinesScreenCheck) {
    const machineStatusObject = machine?.machineStatus;
    const ncFileExist = !!machineStatusObject?.ncFile;
    const batchExist = machineStatusObject?.productionBatchId != null;
    const ncFileStatus = machineStatusObject?.ncFileStatus;

    const shouldPreselectNCFile = ncFileExist;
    const shouldPreselectBatch = ncFileExist && [ncFileStatuses.Unknown, ncFileStatuses.Linked].includes(ncFileStatus) && batchExist;
    const shouldPreselectJobs = shouldPreselectBatch && batch?.links?.length > 0;

    return [
      ...injectConditionalArrayItems(shouldPreselectNCFile, KEYS_TAGS.Clamping),
      ...injectConditionalArrayItems(shouldPreselectBatch, KEYS_TAGS.ProductionBatch),
      ...injectConditionalArrayItems(shouldPreselectJobs, KEYS_TAGS.ProductionOperation),
    ];
  }

  return [];
};
